import HttpService from 'src/services/http';

import { sentry } from './sentry/sentry';

type IpInfo = {
  [key: string]: unknown;
  ip: string;
  country?: string;
  postal?: string;
  city?: string;
};

class IpInfoService extends HttpService {
  async getInfo(): Promise<Record<string, string>> {
    const provider1 = async (): Promise<Record<string, any>> => {
      const response = await fetch('https://ipinfo.io/json');
      if (!response.ok) {
        throw new Error(`ipinfo failed: ${response.status} ${response.statusText}`);
      }

      const data = (await response.json()) as IpInfo;
      if (!data.ip) {
        throw new Error('ipinfo response missing IP');
      }

      return data;
    };

    const provider2 = async (): Promise<Record<string, any>> => {
      const response = await fetch('https://ipapi.co/json');
      if (!response.ok) {
        throw new Error(`ipapi failed: ${response.status} ${response.statusText}`);
      }

      const data = (await response.json()) as IpInfo;
      if (!data.ip) {
        throw new Error('ipapi response missing IP');
      }

      return data;
    };

    try {
      return await Promise.any([provider1(), provider2()]);
    } catch (e: unknown) {
      sentry.captureException(e, {
        extra: {
          message: 'Failed to fetch IP info from both providers',
        },
      });

      return { ip: '', country: '', postal: '', city: '' };
    }
  }
}

const ipInfoService = new IpInfoService();

export { ipInfoService };
